<div class="update-payment-method-dialog">
  <div class="dialog-header">
    <h2 mat-dialog-title>{{ 'INTL_UPDATE_PAYMENT_METHOD' | translate }}</h2>
    <button mat-icon-button (click)="onCancel()" [disabled]="isSaving">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <mat-dialog-content>
    <wai-sepa-payment-setup
      [billingName]="billingContactName"
      [billingEmail]="billingContactEmail"
      [processing]="isSaving"
      (completed)="onPaymentMethodCompleted($event)"
      (cancelled)="onCancel()"
    ></wai-sepa-payment-setup>
  </mat-dialog-content>
</div>
